import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-safe-chat-icon',
  templateUrl: './communication-safe-chat.component.html'
})
export class CommunicationSafeChatComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
